<template>
  <div style="height: 100%; margin: 0px; padding: 0px">
    <a-row style="height: 100%">
      <a-col :span="12">
        <div style="width=100%;text-align:center">
          <p>
            注：家长手机和学生 ID 仅可输入其中一个<br />
            注：呼叫会存在 3-10 秒的延迟，属于正常现象，不要重复呼叫
          </p>

          <div style="margin-left: 10px">
            <span class="input-group-addon" style="margin-right: 20px"
              >请输入</span
            >
            <a-input
              type="text"
              id="phone"
              style="width: 130px"
              :placeholder="studentPhone"
            />
            <a-divider type="vertical" />
            <span style="color: red">或</span>
            <a-divider type="vertical" />
            <a-input
              type="text"
              id="crmid"
              style="width: 150px"
              placeholder="英语/美术项目 学生ID"
            />
            <a-divider type="vertical" />
            <a-input
              type="text"
              id="mathcrmid"
              style="width: 150px"
              placeholder="数学项目 学生ID"
            />
          </div>
          <div style="margin-top: 15px; margin-left: 30px">
            <div style="text-align: center; margin-top: 20px">
              <a-button type="primary" @click="call">呼叫</a-button>
              <a-button
                type="primary"
                style="margin-left: 30px; margin-right: 30px"
                @click="sendSMS"
                :loading="smsSendBtnLoading"
                >{{ smsSendBtnLoading ? "发送中" : "发送短信" }}</a-button
              >
              <!-- <a-button type="primary">设置呼叫提醒</a-button> -->
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 100%; margin-top: 40px">
          <template v-if="this.$store.state.smsBody.smsCode != ''">
            <h2 style="text-align: center">选择的短信模板</h2>
            <div style="margin: 10px">
              {{ this.$store.state.smsBody.smsText }}
            </div>
            <div
              v-html="this.$store.state.smsBody.smsHtml"
              style="margin-left: 10px"
            ></div>
          </template>
        </div>
      </a-col>
      <a-col :span="12" style="height: 100%; overflow: auto">
        <SMSView />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import SMSView from '@/views/components/SMSView.vue'
import vuex from '@/store.js'
import Message from 'ant-design-vue/lib/message'
import { DoubleCallWithPhone, DoubleCallWithCrmID, SendSMS, DoubleCallWithMathCrmID } from '@/api/QkidsApi.js'
export default {
  data: function () {
    return {
      studentPhone: '家长号码',
      smsSendBtnLoading: false
    }
  },
  components: {
    SMSView
  },
  methods: {
    call: function () {
      let phone = (document.getElementById('phone').value).trim()
      var crmid = (document.getElementById('crmid').value).trim()
      let mathcrmid = (document.getElementById('mathcrmid').value).trim()
      console.log('call:', phone, '|', crmid, '|', mathcrmid)
      if (phone === '' && crmid === '' && mathcrmid === '') {
        Message.error('手机号和学生 ID 至少需要输入一项')
      } else if (phone.length > 0 && crmid.length > 0 && mathcrmid.length > 0) {
        Message.error('手机号和学生 ID 只能输入其中一个')
      } else if (phone.length > 0 && (!(/^1[13456789]\d{9}$/.test(phone)))) {
        Message.error('手机号格式错误,只允许呼叫国内手机号用户')
      } else if (phone.length > 0) {
        DoubleCallWithPhone(phone)
          .then(req => {
            if (req.status === 200) {
              Message.info('呼叫成功，请注意在手机上接听')
            } else {
              Message.error(req.msg)
            }
          })
          .catch(err => {
            Message.error('网络错误，请稍后重试，或联系 徐东龙')
            console.log(err)
          })
      } else if (crmid.length > 0) {
        DoubleCallWithCrmID(crmid)
          .then(req => {
            if (req.status === 200) {
              Message.info('呼叫成功，请注意在手机上接听')
              this.studentPhone = req.phone
            } else {
              Message.error(req.msg)
            }
          })
          .catch(err => {
            Message.error('网络错误，请稍后重试，或联系 徐东龙')
            console.log(err)
          })
      } else if (mathcrmid.length > 0) {
        DoubleCallWithMathCrmID(mathcrmid)
          .then(req => {
            if (req.status === 200) {
              Message.info('呼叫成功，请注意在手机上接听')
              this.studentPhone = req.phone
            } else {
              Message.error(req.msg)
            }
          })
          .catch(err => {
            Message.error('网络错误，请稍后重试，或联系 徐东龙')
            console.log(err)
          })
      }
    },
    sendSMS: function () {
      if (vuex.state.smsBody.smsCode === '') {
        Message.error('请选择要发送的短信模板')
      } else {
        this.smsSendBtnLoading = true
        var param = {}
        var isSuc = true
        vuex.state.smsBody.smsParams.forEach(function (item) {
          var value = document.getElementById('param_' + item).value
          var len = value.length
          if (len >= 20) {
            Message.error('${' + item + '} 变量内容超过 20 个字符，请精简后再发送')
            isSuc = false
          }
          if (value === '') {
            isSuc = false
          } else {
            param[item] = value
          }
        })
        this.smsSendBtnLoading = true
        if (isSuc) {
          console.log('param:', param)
          let phone = (document.getElementById('phone')).value.trim()
          let crmid = (document.getElementById('crmid').value).trim()
          let mathcrmid = (document.getElementById('mathcrmid').value).trim()

          let postParam = {
            'phone': phone,
            'crmid': crmid,
            'mathcrmid': mathcrmid,
            'temcode': vuex.state.smsBody.smsCode,
            'param': JSON.stringify(param)
          }
          if (phone === '' && crmid === '' && mathcrmid === '') {
            Message.error('手机号和学生 ID 至少需要输入一项')
            this.smsSendBtnLoading = false
            return
          } else if (phone.length > 0 && (!(/^1[3456789]\d{9}$/.test(phone)))) {
            Message.error('手机号格式错误,手机号只能是纯数字')
            this.smsSendBtnLoading = false
            return
          } else if (phone.length > 0 && crmid.length > 0) {
            Message.error('手机号和学生 ID 只能输入其中一个')
            this.smsSendBtnLoading = false
            return
          } else if (phone.length > 0) {
            postParam['type'] = 'phone'
          } else if (crmid.length > 0) {
            postParam['type'] = 'crmid'
          } else if (mathcrmid.length > 0) {
            postParam['type'] = 'mathcrmid'
          }
          console.log('sms param:', postParam)
          SendSMS(postParam)
            .then(req => {
              if (req.status === 200) {
                Message.info('短信发送成功')
              } else {
                Message.error('发送失败：' + req.msg)
              }
              setTimeout(() => {
                this.smsSendBtnLoading = false
              }, 3000)
              console.log(req)
            })
            .catch(err => {
              this.smsSendBtnLoading = false
              console.log(err)
            })
        } else {
          alert('短信的参数不能为空或变量内容过长')
        }
      }
      console.log('send sms', vuex.state.smsBody.smsParams)
    },
    Oninput: function (event) {
      console.log(event)
    }
  },
  watch: {

  }
}
</script>
<style scoped>
#text-danger {
  color: red;
}
</style>
